<script lang="ts">
  import Modal from "@shared/ui/Modal.svelte";
  import { restoreContract } from "@entities/contract/store.svelte";
  import type { Contract } from "@domain/contract/model";

  interface Props {
    open: boolean;
    contract: Contract;
    onClose: () => void;
    onRestored: (contract: Contract) => void;
  }

  let { open, contract, onClose, onRestored }: Props = $props();

  let reason = $state("");
  let submitting = $state(false);
  let serverError = $state<string | null>(null);

  let contractLabel = $derived(
    contract.deal_name ?? contract.contract_type ?? contract.id,
  );

  $effect(() => {
    if (open) {
      reason = "";
      serverError = null;
    }
  });

  function close() {
    onClose();
  }

  async function handleSubmit(ev: SubmitEvent) {
    ev.preventDefault();
    if (submitting) return;
    submitting = true;
    serverError = null;
    try {
      const updated = await restoreContract(contract.id, reason.trim() || null);
      onRestored(updated);
    } catch (err) {
      serverError = err instanceof Error ? err.message : String(err);
    } finally {
      submitting = false;
    }
  }
</script>

<Modal {open} title="契約を復元" onClose={close}>
  <form id="contract-restore-form" onsubmit={handleSubmit}>
    <p class="target">
      対象契約: <strong>{contractLabel}</strong>
    </p>
    <ul class="notes">
      <li>通常一覧、タイムライン、集計に戻ります。</li>
    </ul>
    <label>
      <span>復元理由（任意）</span>
      <textarea
        bind:value={reason}
        rows="3"
        placeholder="例: 誤ってアーカイブしたため"
      ></textarea>
    </label>
    {#if serverError}<p class="server-error">{serverError}</p>{/if}
  </form>
  {#snippet footer()}
    <button type="button" onclick={close} disabled={submitting}>
      キャンセル
    </button>
    <button
      type="submit"
      form="contract-restore-form"
      class="primary"
      disabled={submitting}
    >
      {submitting ? "復元中…" : "復元"}
    </button>
  {/snippet}
</Modal>

<style>
  form {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  label {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  textarea {
    padding: 8px 10px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    font: inherit;
    background: white;
    resize: vertical;
  }
  .target {
    margin: 0;
    color: #374151;
  }
  .notes {
    margin: 0;
    padding-left: 18px;
    color: #4b5563;
    font-size: 0.875rem;
  }
  .server-error {
    color: #b91c1c;
    margin: 0;
  }
  button {
    padding: 8px 16px;
    border: 1px solid #d1d5db;
    background: white;
    border-radius: 4px;
    cursor: pointer;
    font: inherit;
  }
  button.primary {
    background: #2563eb;
    border-color: #2563eb;
    color: white;
  }
  button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
</style>
